import {
  PaletteColor,
  PaletteOptions,
  SimplePaletteColorOptions,
  PaletteColorOptions,
} from "@mui/material";
import {
  red,
  grey,
  indigo,
  pink,
  green,
  yellow,
  amber,
  blue,
  blueGrey,
} from "@mui/material/colors";
interface CustomPaletteColor {
  50?: string;
  100?: string;
  200?: string;
  300?: string;
  400?: string;
  500?: string;
  600?: string;
  700?: string;
  800?: string;
  900?: string;
}
declare module "@mui/material/styles" {
  interface PaletteColor extends CustomPaletteColor {}
  interface SimplePaletteColorOptions extends CustomPaletteColor {}

  interface Palette {
    primary: PaletteColor;
    secondary: PaletteColor;
    bgColor: {
      grey100: string;
      white: string;
      blueGrey50: string;
      blueGrey100: string;
    };
    textColor: PaletteColor;
  }
  interface PaletteOptions {
    bgColor: {
      grey100: string;
      white: string;
      blueGrey50: string;
      blueGrey100: string;
    };
    textColor: SimplePaletteColorOptions;
  }
}
export const lightModePalette: PaletteOptions = {
  bgColor: {
    grey100: grey[100],
    white: "#fff",
    blueGrey50: blueGrey[50],
    blueGrey100: blueGrey[100],
  },
  primary: {
    "50": "#e8f3fe",
    "100": "#b7d9fa",
    "200": "#94c6f8",
    "300": "#64acf5",
    "400": "#459cf3",
    main: "#1783f0",
    "600": "#1577da",
    "700": "#105daa",
    "800": "#0d4884",
    "900": "#0a3765",
  },

  secondary: {
    "50": "#fbf4eb",
    "100": "#f3ddc1",
    "200": "#eecca3",
    "300": "#e6b578",
    "400": "#e1a65e",
    main: "#d99036",
    "600": "#c58331",
    "700": "#9a6626",
    "800": "#774f1e",
    "900": "#5b3c17",
  },
  info: {
    main: blueGrey[100],
    light: blueGrey[50],
    dark: blueGrey[400],
  },
  success: {
    main: green[500],
    light: green[50],
    dark: green[900],
  },
  warning: {
    main: yellow[700],
    dark: amber[600],
    light: amber[100],
  },
  error: {
    main: red[600],
    light: red[50],
    dark: red[800],
  },

  textColor: {
    main: grey[800],
    light: grey[500],
    dark: "#262626",
  },
};

export const darkModePalette: PaletteOptions = {
  bgColor: {
    grey100: grey[900],
    white: grey[800],
    blueGrey50: grey[900],
    blueGrey100: grey[800],
  },
  primary: {
    "50": "#e8f3fe",
    "100": "#b7d9fa",
    "200": "#94c6f8",
    "300": "#64acf5",
    "400": "#459cf3",
    main: "#1783f0",
    "600": "#1577da",
    "700": "#105daa",
    "800": "#0d4884",
    "900": "#0a3765",
  },

  secondary: {
    "50": "#fbf4eb",
    "100": "#f3ddc1",
    "200": "#eecca3",
    "300": "#e6b578",
    "400": "#e1a65e",
    main: "#d99036",
    "600": "#c58331",
    "700": "#9a6626",
    "800": "#774f1e",
    "900": "#5b3c17",
  },
  success: {
    main: green[500],
    light: grey[700],
    dark: green[900],
  },
  warning: {
    main: yellow[700],
    dark: amber[600],
    light: amber[100],
  },
  error: {
    main: red[600],
    light: red[50],
    dark: red[800],
  },
  textColor: {
    main: "#fff",
    light: grey[400],
    dark: grey[100],
  },
};
